<a routerLink="/sgkz001d">
  <div id="title" style="height: 64px" fxLayout="row wrap" fxLayoutAlign="start center">
    <span style="padding-left: 20px">
      <img src="outer-assets/sg-features/icon/cursus/logo.svg" alt="logo">
    </span>
  </div>
</a>

<mat-nav-list>

  <div *ngFor="let dto of dtoList">
    <app-top-side-menu [inputTitle]="dto.title" [inputTopItemId]="getTopItemId(dto.title)"></app-top-side-menu>
  </div>
 
  <mat-divider></mat-divider>

  <mat-list-item (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
    <div id="menuLogout" class="menu-item">ログアウト</div>
  </mat-list-item>
</mat-nav-list>